"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var s = require("./PaymentDetails.scss");
var Fields_1 = require("./../../components/Fields");
var Loader_1 = require("./../../components/Loader");
var PayButton_1 = require("./../PayButton");
var FormsStore_1 = require("./../../data/FormsStore");
var PaymentsStore_1 = require("./../../data/PaymentsStore");
var mandatoryFieldsUIUtils_1 = require("../../utils/mandatoryFieldsUIUtils");
var wix_experiments_1 = require("wix-experiments");
var MANDATORY_FIELDS_FORM = 'MANDATORY_FIELDS_FORM';
var PaymentDetails = (function (_super) {
    __extends(PaymentDetails, _super);
    function PaymentDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isComponentMounted = false;
        _this.validateForm = FormsStore_1.default.validate.bind(null, MANDATORY_FIELDS_FORM);
        _this.state = {
            formData: {},
            mandatoryFields: [],
            isLoadingMandatoryFields: true,
            isMandatoryFieldsEnabled: false,
        };
        _this.loadMandatoryFields = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.state.isMandatoryFieldsEnabled) return [3 /*break*/, 2];
                        this.safeSetState({
                            isLoadingMandatoryFields: true,
                        });
                        return [4 /*yield*/, PaymentsStore_1.default.fetchMandatoryFields()];
                    case 1:
                        _a.sent();
                        this.safeSetState({
                            isLoadingMandatoryFields: false,
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        this.safeSetState({
                            isLoadingMandatoryFields: false,
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.checkIsCountryChanged = function (formData) {
            var currentCountry = _this.state.formData.countryCode;
            var nextCountry = formData.countryCode;
            /* istanbul ignore next */
            if (currentCountry && nextCountry && currentCountry.value !== nextCountry.value) {
                _this.props.paymentsSDK.setCountry(nextCountry.value);
                _this.loadMandatoryFields();
            }
        };
        /**
         * Returns camel-cased variant of mandatory field name
         * @example holder_id => holderId
         * @example holder_id_whatever => holderIdWhatever
         * @example holder_ => holder
         * @param {string} value Any string value
         * @returns {string}
         */
        _this.camelCased = function (value) {
            /* istanbul ignore next */
            return value.replace(/_.?/g, _this.replaceWithCamelCase);
        };
        /* istanbul ignore next */
        _this.replaceWithCamelCase = function (part) {
            /* istanbul ignore next */
            return (part && part[1]) ? part[1].toUpperCase() : '';
        };
        _this.excludeProvidedMandatoryFields = function (mf) {
            var providedMandatoryFields = [];
            /* istanbul ignore next */
            if (_this.props.mandatoryFields) {
                /* istanbul ignore next */
                providedMandatoryFields = Object.keys(_this.props.mandatoryFields).map(function (mandatoryFieldName) {
                    return _this.camelCased(mandatoryFieldName);
                });
            }
            return providedMandatoryFields.indexOf(mf.name) < 0;
        };
        _this.safeSetState = function (state, callback) {
            if (_this.isComponentMounted) {
                _this.setState(state, callback);
            }
        };
        _this.updateSDKCurrentMandatoryFields = function () {
            var formData = _this.state.formData;
            var mandatoryFieldsNames = Object.keys(formData);
            // Update SDK mandatory fields with current values
            mandatoryFieldsNames.forEach(function (name) {
                try {
                    _this.props.paymentsSDK.setMandatoryField(name, { value: formData[name].value });
                }
                catch (e) {
                    /* this line will be reached only if something went wrong with sdk */
                    /* istanbul ignore next */
                    // Commented due to https://jira.wixpress.com/browse/WCN-1878
                    // console.info('Something went wrong, maybe sdk not inited', e);
                }
            });
        };
        _this.updateSDKWithProvidedMandatoryFields = function () {
            if (!_this.props.mandatoryFields) {
                return null;
            }
            // Update SDK mandatory fields with provided values
            Object.keys(_this.props.mandatoryFields).forEach(function (mfKey) {
                try {
                    _this.props.paymentsSDK.setMandatoryField(mfKey, { value: _this.props.mandatoryFields[mfKey] });
                }
                catch (e) {
                    /* this line will be reached only if something went wrong with sdk */
                    /* istanbul ignore next */
                    // Commented due to https://jira.wixpress.com/browse/WCN-1878
                    // console.info('Something went wrong, maybe sdk not inited', e);
                }
            });
        };
        _this.renderPaymentMethod = function () {
            if (_this.state.isLoadingMandatoryFields) {
                return React.createElement(Loader_1.default, null);
            }
            return (React.createElement("div", { className: s.fieldsGroup }, _this.renderMandatoryFields()));
        };
        _this.renderMandatoryFields = function () {
            /* istanbul ignore next */
            if (_this.props.isMethodCollapsed) {
                /* istanbul ignore next */
                return null;
            }
            var fields = mandatoryFieldsUIUtils_1.getFieldsWithColumns(_this.state.mandatoryFields.filter(_this.excludeProvidedMandatoryFields), _this.props.mandatoryFieldsGroups);
            return fields.map(function (field) {
                var className = s.field;
                if (field.column === 'left') {
                    className = s.fieldLeft;
                }
                else if (field.column === 'right') {
                    className = s.fieldRight;
                }
                return (React.createElement("div", { key: field.name, className: className },
                    React.createElement(Fields_1.Field, { data: field, formData: _this.state.formData, formName: MANDATORY_FIELDS_FORM })));
            });
        };
        _this.validate = function () {
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var isMandatoryFieldsValid, isPaymentMethodValid, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isMandatoryFieldsValid = this.validateForm();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.props.paymentsSDK.validate(this.props.paymentMethod.paymentMethod)];
                        case 2:
                            isPaymentMethodValid = _a.sent();
                            resolve({
                                isValid: (isMandatoryFieldsValid && isPaymentMethodValid.isValid) || false,
                                /* istanbul ignore next */
                                invalidFields: /* istanbul ignore next */ isPaymentMethodValid.invalidFields || [],
                            });
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            /* istanbul ignore next */
                            reject();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        };
        return _this;
    }
    PaymentDetails.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var experiments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, PaymentsStore_1.default.initPayments({
                            locale: this.props.locale,
                            paymentsSDK: this.props.paymentsSDK,
                            orderId: this.props.orderId,
                            paymentMethod: this.props.paymentMethod,
                        })];
                    case 1:
                        _a.sent();
                        this.isComponentMounted = true;
                        if (!this.props.isMandatoryFieldsEnabled) return [3 /*break*/, 2];
                        this.safeSetState({
                            isMandatoryFieldsEnabled: this.props.isMandatoryFieldsEnabled,
                        });
                        return [3 /*break*/, 4];
                    case 2:
                        experiments = new wix_experiments_1.default({
                            baseUrl: 'https://www.wix.com',
                            scope: 'cashier',
                        });
                        /* istanbul ignore next */ return [4 /*yield*/, experiments.ready()];
                    case 3:
                        /* istanbul ignore next */ _a.sent();
                        /* istanbul ignore next */
                        this.safeSetState({
                            isMandatoryFieldsEnabled: experiments.enabled('specs.cashier.MandatoryFields'),
                        });
                        _a.label = 4;
                    case 4:
                        PaymentsStore_1.default.subscribe('mandatoryFields', function (mandatoryFields) {
                            _this.safeSetState({
                                mandatoryFields: mandatoryFields,
                            });
                        });
                        return [4 /*yield*/, this.loadMandatoryFields()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentDetails.prototype.componentWillReceiveProps = function (nextProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.props.paymentMethod !== nextProps.paymentMethod)) return [3 /*break*/, 2];
                        PaymentsStore_1.default.setPaymentMethod({
                            paymentMethod: nextProps.paymentMethod,
                        });
                        return [4 /*yield*/, this.loadMandatoryFields()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.props.mandatoryFields !== nextProps.mandatoryFields && this.state.isMandatoryFieldsEnabled) {
                            this.updateSDKWithProvidedMandatoryFields();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentDetails.prototype.componentDidUpdate = function (prevProps, prevState) {
        /* istanbul ignore next */
        var prevCountryCode = prevState.formData.countryCode && prevState.formData.countryCode.value;
        var curCountryCode = this.state.formData &&
            this.state.formData.countryCode &&
            this.state.formData.countryCode.value;
        var isCountryChanged = prevCountryCode !== curCountryCode;
        if (this.state.isMandatoryFieldsEnabled && prevState.mandatoryFields.length !== this.state.mandatoryFields.length) {
            this.initMandatoryFieldForm();
        }
        if (isCountryChanged && this.props.onCountryChange) {
            this.props.onCountryChange(this.state.formData && this.state.formData.countryCode);
        }
    };
    PaymentDetails.prototype.componentWillUnmount = function () {
        this.isComponentMounted = false;
    };
    PaymentDetails.prototype.initMandatoryFieldForm = function () {
        var _this = this;
        var defaultFields = this.state.mandatoryFields.filter(this.excludeProvidedMandatoryFields).reduce(function (res, field) {
            // TODO need to refactor tests
            /* istanbul ignore next */
            return __assign({}, res, (_a = {}, _a[field.name] = {
                name: field.name,
                isValid: field.name === 'countryCode' && _this.props.countryCode ? true : false,
                value: field.name === 'countryCode' && _this.props.countryCode ? _this.props.countryCode : undefined,
            }, _a));
            var _a;
        }, {});
        FormsStore_1.default.reset();
        FormsStore_1.default.initForm(MANDATORY_FIELDS_FORM, defaultFields);
        this.updateSDKWithProvidedMandatoryFields();
        FormsStore_1.default.subscribe(MANDATORY_FIELDS_FORM, function (formData) {
            _this.checkIsCountryChanged(formData);
            _this.safeSetState({ formData: formData }, function () { return _this.updateSDKCurrentMandatoryFields(); });
        });
        this.safeSetState({
            formData: FormsStore_1.default.getFormData(MANDATORY_FIELDS_FORM),
        });
    };
    PaymentDetails.prototype.renderPaymentButton = function () {
        if (this.props.externalPayButton || !this.props.isMobileApplication) {
            return null;
        }
        return (React.createElement("div", { className: s.payButton },
            React.createElement(PayButton_1.default, { paymentsSDK: this.props.paymentsSDK, paymentMethod: this.props.paymentMethod, orderId: this.props.orderId })));
    };
    PaymentDetails.prototype.render = function () {
        return (React.createElement("div", { "data-hook": "cashier-payments-method-payment-details", className: s.root },
            this.renderPaymentMethod(),
            this.renderPaymentButton()));
    };
    PaymentDetails.defaultProps = {
        mandatoryFieldsGroups: [
            ['countryCode', 'state'],
            ['zipCode', 'phone'],
            ['street', 'houseNumber'],
        ],
        isMandatoryFieldsEnabled: false,
        isMethodCollapsed: false,
    };
    return PaymentDetails;
}(React.Component));
exports.default = PaymentDetails;
//# sourceMappingURL=PaymentDetails.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/containers/PaymentDetails/PaymentDetails.js
// module id = 218
// module chunks = 0 1